// Unified Abay AI bus.
//
// Every AI entry point in the app (bottom nav, homepage banner, property
// pages, search results, mortgage/investment pages) calls openAbayAI/askAbayAI.
// Instead of a floating panel, these now NAVIGATE to the dedicated full-screen
// Abay AI experience at /abay-ai, carrying an optional prefill/auto-send
// message. A tiny <AbayAIBridge/> mounted inside the Router registers the
// navigate function so this module can route from anywhere (even non-React
// callers). This keeps ONE continuous conversation + shared memory.

let _navigate = null;
let _pending = null;

export function registerAbayNavigate(fn) {
  _navigate = typeof fn === "function" ? fn : null;
}

// Consumed by the AbayAIExperience screen on mount to prefill / auto-send.
export function consumePendingAbay() {
  const p = _pending;
  _pending = null;
  return p;
}

function go(message, autosend) {
  const text = (message || "").trim();
  _pending = { message: text, autosend: Boolean(autosend && text) };
  try {
    if (_navigate) _navigate("/abay-ai");
    else window.location.assign("/abay-ai");
  } catch {
    try { window.location.assign("/abay-ai"); } catch { /* no-op */ }
  }
}

// Open the assistant (optionally prefilling the composer, without sending).
export function openAbayAI(message) {
  go(message, false);
}

// Open the assistant AND auto-send the message immediately.
export function askAbayAI(message) {
  go(message, true);
}
